import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(function () {
    // Animation
    let defaultEase = "circ.inOut";

    function loadAnimation() {
        setTimeout(() => {
            gsap.to(".hospital-list .list-item", {
                opacity: 1,
                duration: 0.5,
                ease: defaultEase,
            })
          
            gsap.to(".hospital-list .list-item .item-text", {
                y: 0,
                opacity: 1,
                duration: 0.8,
                delay: 0.1,
                ease: defaultEase,
            })
          
            gsap.to(".hospital-list .list-item .item-img", {
                y: 0,
                opacity: 1,
                duration: 0.8,
                delay: 0.2,
                ease: defaultEase,
            })
        }, 500);
    }

    if ($(window).width() >= 1200) {
        loadAnimation();
    }

    $(window).resize(function () {
        if ($(window).width() >= 1200) {
            loadAnimation();
        }
    });
})